import { isDiscountedSources } from 'utils/campaign';
import { Settings } from 'utils/constants/dynamicSettings';

import useSettings from 'hooks/useSettings';

import { useSelector } from 'store/utils';

export const useMinBudget = (): { minBudget: number; minDailyBudget: number } => {
    const adSource = useSelector((state) => state.createCampaign.adSource);

    const isDiscounted = isDiscountedSources(adSource);

    const settings = useSettings();
    const normalMinBudget = settings(Settings.NormalMinBudget) as number;
    const discountedMinBudget = settings(Settings.DiscountedMinBudget) as number;
    const normalMinDailyBudget = settings(Settings.NormalMinDailyBudget) as number;
    const discountedMinDailyBudget = settings(Settings.DiscountedMinDailyBudget) as number;

    const minDailyBudget = isDiscounted ? discountedMinDailyBudget : normalMinDailyBudget;
    const minBudget = isDiscounted ? discountedMinBudget : normalMinBudget;

    return { minBudget, minDailyBudget };
};
